/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { FC } from 'react';
import { AutoComplete } from 'antd';
import { clsx } from 'clsx';

import { ISearchInputMainProps } from '../models/types';
import { SearchInputMainProvider } from '../providers';

import { SearchInput } from './searchInput';

import styles from './styles.module.scss';

export const SearchInputMain: FC<ISearchInputMainProps> = ({
  className,
  onSelect,
  onChange,
  options,
  placeholder,
  style,
  value,
  isLoading,
  onClearClick,
}) => {
  return (
    <div>
      <SearchInputMainProvider>
        <AutoComplete
          className={clsx([styles['search-input'], className])}
          value={value}
          options={options}
          onSelect={onSelect}
          listHeight={300}
          dropdownStyle={{
            borderRadius: 10,
          }}
        >
          <SearchInput
            placeholder={placeholder}
            onChange={onChange}
            value={value as string}
            isLoading={isLoading}
            onClearClick={onClearClick}
            style={{
              ...style,
            }}
          />
        </AutoComplete>
      </SearchInputMainProvider>
    </div>
  );
};
